// import {
//     Box,
//     Container,
//     Typography,
//     Chip
//   } from '@mui/material';
//   import { useEffect, useState } from 'react';
//   import templateAsset from '../assets/template-asset-1.png';
//   import phoneAsset from '../assets/phone2.png';
//   import { motion } from "framer-motion";
  
//   const MobileShowcasePerfect = () => {
//     const [visibleFeatures, setVisibleFeatures] = useState(new Set());
  
//     // Karma Özellikler - Hem Eski Hem Yeni
//     const features = [
//       {
//         id: 1,
//         title: 'Gerçek Zamanlı Analiz',
//         description: 'Ayrıntılı gösterge tabloları ile performans anında takip edin. Hangi kitlenizi analiz edin ve içeriği maksimum etki ve etkileşim için optimize edin.',
//         icon: '📊',
//         color: '#3b82f6'
//       },
//       {
//         id: 2,
//         title: 'Sosyal Medya Entegrasyonu',
//         description: 'Sorunsuz sosyal paylaşımla erişimi genişletin. Okuyucularla bağlantı kurun ve hikayelerinizi tüm platformlarda güçlendirin. 10+ platform desteği.',
//         icon: '📱',
//         color: '#10b981'
//       },
//       {
//         id: 3,
//         title: 'Özelleştirilebilir Şablonlar',
//         description: 'Esnek şablonlarla benzersiz tasarımlar oluşturun. Sitenizi markanızı yansıtacak ve okuyucuların ilgisini etkili bir şekilde çekecek şekilde uyarlayın.',
//         icon: '🎨',
//         color: '#8b5cf6'
//       },
//       {
//         id: 4,
//         title: 'Gelişmiş Güvenlik',
//         description: 'İçeriğinizi güçlü güvenlik özellikleriyle koruyun. SSL şifreleme, iki faktörlü kimlik doğrulama ve otomatik yedekleme ile verileriniz her zaman güvende.',
//         icon: '🔒',
//         color: '#ef4444'
//       },
//       {
//         id: 5,
//         title: 'Otomatik Yedeklemeler',
//         description: 'Otomatik yedeklemelerle veri güvenliğini sağlayın. Değerli içeriklerinizi asla kaybetmeyin ve her zaman içiniz rahat olsun. Günlük yedekleme.',
//         icon: '💾',
//         color: '#f59e0b'
//       },
//       {
//         id: 6,
//         title: 'Reklam Yönetimi',
//         description: 'Google AdSense ve programatik reklam desteği. Banner, native ve video reklam alanları. Detaylı gelir raporları ve optimizasyon önerileri.',
//         icon: '💰',
//         color: '#ec4899'
//       }
//     ];
  
//     // Intersection observer
//     useEffect(() => {
//       const observer = new IntersectionObserver(
//         (entries) => {
//           entries.forEach((entry) => {
//             if (entry.isIntersecting) {
//               const index = parseInt(entry.target.dataset.index);
//               setTimeout(() => {
//                 setVisibleFeatures(prev => new Set([...prev, index]));
//               }, index * 150);
//             }
//           });
//         },
//         { threshold: 0.3 }
//       );
  
//       const elements = document.querySelectorAll('[data-index]');
//       elements.forEach(el => observer.observe(el));
  
//       return () => observer.disconnect();
//     }, []);
  
//     return (
//       <Box 
//         sx={{
//           background: 'linear-gradient(101deg, #15254b 0%, #1e3a8a 100%)',
//         }}
//       >
//         <Box 
//           sx={{
//             py: { xs: 10, md: 16 },
//             backgroundColor: '#f1f6fb',
//             borderRadius: { xs: 0, md: '400px 0 400px 0' },
//             position: 'relative',
//             overflow: 'hidden',
//             '&::before': {
//               content: '""',
//               position: 'absolute',
//               top: 0,
//               left: 0,
//               right: 0,
//               bottom: 0,
//               background: `
//                 radial-gradient(circle at 20% 20%, rgba(30, 64, 175, 0.05) 0%, transparent 50%),
//                 radial-gradient(circle at 80% 80%, rgba(220, 38, 38, 0.05) 0%, transparent 50%),
//                 radial-gradient(circle at 50% 50%, rgba(5, 150, 105, 0.03) 0%, transparent 50%)
//               `,
//               pointerEvents: 'none'
//             }
//           }}
//         >
//           {/* Beyaz shape görsel */}
//           <Box
//             sx={{
//               position: 'absolute',
//               inset: 0,
//               backgroundImage: `url(${templateAsset})`,
//               backgroundSize: 'cover',
//               backgroundPosition: 'center',
//               backgroundRepeat: 'no-repeat',
//               opacity: 0.8,
//               filter: 'brightness(1.5) contrast(1.3)',
//               zIndex: 1,
//             }}
//           />
          
//           <Container maxWidth="lg" sx={{ position: 'relative', height: '100%', zIndex: 2 }}>
//             {/* Header */}
//             <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 10 } }}>
//               <Chip
//                 label="PLATFORM ÖZELLİKLERİ"
//                 sx={{
//                   fontSize: '0.85rem',
//                   fontWeight: 900,
//                   letterSpacing: '0.1em',
//                   background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
//                   color: 'white',
//                   mb: 3,
//                   px: 2,
//                   py: 2.5
//                 }}
//               />
  
//               <Typography
//                 variant="h2"
//                 sx={{
//                   fontSize: { xs: '2.8rem', md: '4rem' },
//                   fontWeight: 800,
//                   mb: 4,
//                   background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
//                   backgroundClip: 'text',
//                   WebkitBackgroundClip: 'text',
//                   WebkitTextFillColor: 'transparent',
//                   fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
//                   lineHeight: 1.1,
//                   position: 'relative',
//                   '&::after': {
//                     content: '""',
//                     position: 'absolute',
//                     bottom: -8,
//                     left: '50%',
//                     transform: 'translateX(-50%)',
//                     width: 80,
//                     height: 4,
//                     background: 'linear-gradient(90deg, #1e40af, #dc2626)',
//                     borderRadius: 2
//                   }
//                 }}
//               >
//                 Yayınlama Gücünü Ortaya Çıkarın
//               </Typography>
  
//               <Typography
//                 variant="h5"
//                 sx={{
//                   fontSize: { xs: '1.3rem', md: '1.5rem' },
//                   color: '#64748b',
//                   maxWidth: 700,
//                   mx: 'auto',
//                   lineHeight: 1.6,
//                   fontWeight: 400,
//                   mb: 6
//                 }}
//               >
//                 Haber platformu ile benzersiz kontrol ve verimlilik deneyimleyin. 
//                 Yayıncılık iş akışınızı dönüştürün ve hedef kitlenizin ilgisini çekin.
//               </Typography>
//             </Box>
  
//             {/* Ana Container - Telefon ve Özellikler */}
//             <Box
//               sx={{
//                 width: '100%',
//                 height: '100%',
//                 display: 'flex',
//                 flexDirection: { xs: 'column', md: 'row' },
//                 alignItems: 'center',
//                 justifyContent: 'space-around',
//                 gap: { xs: 4, md: 5 }
//               }}
//             >
//               {/* Sol Taraf Özellikler */}
//               <Box 
//                 sx={{ 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   alignItems: 'center', 
//                   justifyContent: 'space-around', 
//                   height: { xs: 'auto', md: '700px' }, 
//                   width: '100%',
//                   gap: { xs: 3, md: 4 }
//                 }}
//               >
//                 {features?.slice(0, 3).map((feature, index) => (
//                   <Box
//                     component={motion.div}
//                     initial={{ opacity: 0, x: -100 }}
//                     whileInView={{ opacity: 1, x: 0 }}
//                     transition={{ duration: 0.5, delay: index * 0.1, ease: "easeOut" }}
//                     viewport={{ once: true }}
//                     key={feature.id}
//                     data-index={index}
//                     sx={{
//                       gap: 2,
//                       width: '100%',
//                       display: 'flex',
//                       flexDirection: 'row',
//                       alignItems: { xs: 'center', md: 'flex-end' },
//                       justifyContent: { xs: 'center', md: 'flex-end' },
//                       background: 'transparent',
//                       cursor: 'pointer',
//                       '&:hover': {
//                         '& .feature-dot': {
//                           transform: 'scale(1.3)',
//                           boxShadow: `0 0 20px ${feature.color}`
//                         },
//                         '& .feature-content': {
//                           transform: 'translateX(-5px)'
//                         },
//                         '& .feature-emoji': {
//                           transform: 'scale(1.2) rotate(10deg)'
//                         }
//                       },
//                       transition: 'all 0.3s ease',
//                       [theme => theme.breakpoints.down('md')]: {
//                         flexDirection: 'column',
//                         alignItems: 'center'
//                       }
//                     }}
//                   >
//                     {/* Emoji Icon */}
//                     <Box
//                       className="feature-emoji"
//                       sx={{
//                         fontSize: '3rem',
//                         mb: { xs: 1, md: 0 },
//                         order: { xs: 1, md: 2 },
//                         ml: { xs: 0, md: 2 },
//                         transition: 'all 0.3s ease'
//                       }}
//                     >
//                       {feature.icon}
//                     </Box>
  
//                     {/* Renkli Nokta */}
//                     <Box 
//                       className="feature-dot"
//                       sx={{
//                         padding: { xs: 2, md: 1 },
//                         borderRadius: '50%',
//                         border: '1px solid rgb(255 255 255 / 26%)',
//                         boxShadow: `0 0 10px ${feature.color}66`,
//                         transition: 'all 0.3s ease',
//                         order: { xs: 2, md: 3 }
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           width: { xs: 10, md: 12 },
//                           height: { xs: 10, md: 12 },
//                           background: feature.color,
//                           borderRadius: '50%',
//                           boxShadow: `0 0 15px ${feature.color}`
//                         }}
//                       />
//                     </Box>
  
//                     {/* Özellik İçeriği */}
//                     <Box 
//                       className="feature-content"
//                       sx={{ 
//                         order: { xs: 3, md: 1 },
//                         transition: 'transform 0.3s ease'
//                       }}
//                     >
//                       <Typography
//                         variant="h5"
//                         sx={{
//                           fontWeight: 700,
//                           color: '#1e293b',
//                           mb: 1.5,
//                           fontSize: { xs: '1.2rem', md: '1.4rem' },
//                           textAlign: { xs: 'center', md: 'right' },
//                           lineHeight: 1.2
//                         }}
//                       >
//                         {feature.title}
//                       </Typography>
  
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           color: '#475569',
//                           lineHeight: 1.6,
//                           fontSize: { xs: '0.95rem', md: '1rem' },
//                           textAlign: { xs: 'center', md: 'right' }
//                         }}
//                       >
//                         {feature.description}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
  
//               {/* Merkezdeki Telefon */}
//               <Box
//                 component={motion.div}
//                 initial={{ opacity: 0, scale: 0.8 }}
//                 whileInView={{ opacity: 1, scale: 1 }}
//                 transition={{ duration: 0.8, ease: "easeOut" }}
//                 viewport={{ once: true }}
//                 sx={{
//                   position: 'relative',
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}
//               >
//                 <Box
//                   component={'img'}
//                   src={phoneAsset}
//                   alt="Platform Showcase"
//                   sx={{
//                     width: { xs: '80%', md: '28%' },
//                     maxWidth: '350px',
//                     zIndex: 2,
//                     filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.2))',
//                     animation: 'float 6s ease-in-out infinite'
//                   }}
//                 />
  
//                 {/* Floating Stats Badge - Sol Alt */}
//                 <Box
//                   component={motion.div}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6, delay: 0.8 }}
//                   viewport={{ once: true }}
//                   sx={{
//                     position: 'absolute',
//                     bottom: { xs: -20, md: 50 },
//                     left: { xs: '50%', md: -50 },
//                     transform: { xs: 'translateX(-50%)', md: 'none' },
//                     background: 'rgba(255, 255, 255, 0.95)',
//                     backdropFilter: 'blur(10px)',
//                     borderRadius: 3,
//                     p: 2.5,
//                     boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
//                     border: '2px solid #10b981',
//                     display: { xs: 'none', md: 'block' }
//                   }}
//                 >
//                   <Typography
//                     variant="h4"
//                     sx={{
//                       fontWeight: 800,
//                       color: '#10b981',
//                       mb: 0.5,
//                       lineHeight: 1
//                     }}
//                   >
//                     70+
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: '#64748b',
//                       fontWeight: 600,
//                       fontSize: '0.85rem'
//                     }}
//                   >
//                     Widget
//                   </Typography>
//                 </Box>
  
//                 {/* Floating Stats Badge - Sağ Üst */}
//                 <Box
//                   component={motion.div}
//                   initial={{ opacity: 0, y: -20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.6, delay: 1 }}
//                   viewport={{ once: true }}
//                   sx={{
//                     position: 'absolute',
//                     top: { xs: -20, md: 50 },
//                     right: { xs: '50%', md: -50 },
//                     transform: { xs: 'translateX(50%)', md: 'none' },
//                     background: 'rgba(255, 255, 255, 0.95)',
//                     backdropFilter: 'blur(10px)',
//                     borderRadius: 3,
//                     p: 2.5,
//                     boxShadow: '0 15px 40px rgba(0, 0, 0, 0.15)',
//                     border: '2px solid #3b82f6',
//                     display: { xs: 'none', md: 'block' }
//                   }}
//                 >
//                   <Typography
//                     variant="h4"
//                     sx={{
//                       fontWeight: 800,
//                       color: '#3b82f6',
//                       mb: 0.5,
//                       lineHeight: 1
//                     }}
//                   >
//                     1s
//                   </Typography>
//                   <Typography
//                     variant="caption"
//                     sx={{
//                       color: '#64748b',
//                       fontWeight: 600,
//                       fontSize: '0.85rem'
//                     }}
//                   >
//                     Yükleme Hızı
//                   </Typography>
//                 </Box>
//               </Box>
  
//               {/* Sağ Taraf Özellikler */}
//               <Box 
//                 sx={{ 
//                   display: 'flex', 
//                   flexDirection: 'column', 
//                   alignItems: 'flex-start', 
//                   justifyContent: 'space-around', 
//                   height: { xs: 'auto', md: '700px' }, 
//                   width: '100%',
//                   gap: { xs: 3, md: 4 }
//                 }}
//               >
//                 {features?.slice(3, 6).map((feature, index) => (
//                   <Box
//                     component={motion.div}
//                     initial={{ opacity: 0, x: 100 }}
//                     whileInView={{ opacity: 1, x: 0 }}
//                     transition={{ duration: 0.5, delay: index * 0.1, ease: "easeOut" }}
//                     viewport={{ once: true }}
//                     key={feature.id}
//                     data-index={index + 3}
//                     sx={{
//                       gap: 2,
//                       width: '100%',
//                       display: 'flex',
//                       flexDirection: 'row',
//                       alignItems: { xs: 'center', md: 'flex-start' },
//                       justifyContent: { xs: 'center', md: 'flex-start' },
//                       background: 'transparent',
//                       cursor: 'pointer',
//                       '&:hover': {
//                         '& .feature-dot': {
//                           transform: 'scale(1.3)',
//                           boxShadow: `0 0 20px ${feature.color}`
//                         },
//                         '& .feature-content': {
//                           transform: 'translateX(5px)'
//                         },
//                         '& .feature-emoji': {
//                           transform: 'scale(1.2) rotate(-10deg)'
//                         }
//                       },
//                       transition: 'all 0.3s ease',
//                       [theme => theme.breakpoints.down('md')]: {
//                         flexDirection: 'column',
//                         alignItems: 'center'
//                       }
//                     }}
//                   >
//                     {/* Renkli Nokta */}
//                     <Box 
//                       className="feature-dot"
//                       sx={{
//                         padding: { xs: 2, md: 1 },
//                         borderRadius: '50%',
//                         border: '1px solid rgb(255 255 255 / 26%)',
//                         boxShadow: `0 0 10px ${feature.color}66`,
//                         transition: 'all 0.3s ease',
//                         order: { xs: 2, md: 1 }
//                       }}
//                     >
//                       <Box
//                         sx={{
//                           width: { xs: 10, md: 12 },
//                           height: { xs: 10, md: 12 },
//                           background: feature.color,
//                           borderRadius: '50%',
//                           boxShadow: `0 0 15px ${feature.color}`
//                         }}
//                       />
//                     </Box>
  
//                     {/* Emoji Icon */}
//                     <Box
//                       className="feature-emoji"
//                       sx={{
//                         fontSize: '3rem',
//                         mb: { xs: 1, md: 0 },
//                         order: { xs: 1, md: 2 },
//                         mr: { xs: 0, md: 2 },
//                         transition: 'all 0.3s ease'
//                       }}
//                     >
//                       {feature.icon}
//                     </Box>
  
//                     {/* Özellik İçeriği */}
//                     <Box 
//                       className="feature-content"
//                       sx={{ 
//                         order: { xs: 3, md: 3 },
//                         transition: 'transform 0.3s ease'
//                       }}
//                     >
//                       <Typography
//                         variant="h5"
//                         sx={{
//                           fontWeight: 700,
//                           color: '#1e293b',
//                           mb: 1.5,
//                           fontSize: { xs: '1.2rem', md: '1.4rem' },
//                           textAlign: { xs: 'center', md: 'left' },
//                           lineHeight: 1.2
//                         }}
//                       >
//                         {feature.title}
//                       </Typography>
  
//                       <Typography
//                         variant="body1"
//                         sx={{
//                           color: '#475569',
//                           lineHeight: 1.6,
//                           fontSize: { xs: '0.95rem', md: '1rem' },
//                           textAlign: { xs: 'center', md: 'left' }
//                         }}
//                       >
//                         {feature.description}
//                       </Typography>
//                     </Box>
//                   </Box>
//                 ))}
//               </Box>
//             </Box>
//           </Container>
  
//           {/* CSS Animations */}
//           <style jsx>{`
//             @keyframes float {
//               0%, 100% { 
//                 transform: translateY(0);
//               }
//               50% { 
//                 transform: translateY(-20px);
//               }
//             }
//           `}</style>
//         </Box>
//       </Box>
//     );
//   };
  
//  export default MobileShowcasePerfect;


import {
  Box,
  Container,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import templateAsset from '../assets/template-asset-1.png';
import phoneAsset from '../assets/phone2.png';
import { motion } from "framer-motion";

const MobileShowcasePerfect = () => {
  const [visibleFeatures, setVisibleFeatures] = useState(new Set());

  // Görseldeki tam özellikler - Birebir aynı
  const features = [
    {
      id: 1,
      title: 'Gerçek Zamanlı Analiz',
      description: 'Ayrıntılı gösterge tabloları ile performans anında takip edin. Hangi kitlenizi analayın ve içeriği maksimum etki ve etkileşim için optimize edin.',
      position: { top: '15%', left: '8%' }
    },
    {
      id: 2,
      title: 'Sosyal Bütünleşme',
      description: 'Sorunsuz sosyal paylaşımla erişimi genişletin. Okuyucularla bağlantı kurun ve hikayelerinizi tüm platformlarda güçlendirin.',
      position: { top: '15%', right: '8%' }
    },
    {
      id: 3,
      title: 'Özelleştirilebilir Şablonlar',
      description: 'Esnek şablonlarla benzersiz tasarımlar oluşturun. Sitenizi markanızı yansıtacak ve okuyucuların ilgisini etkili bir şekilde çekecek şekilde uyarlayın.',
      position: { top: '50%', left: '5%' }
    },
    {
      id: 4,
      title: 'Gelişmiş Güvenlik',
      description: 'İçeriğinizi güçlü güvenlik özellikleriyle koruyun. Haberlerinizin bütünlüğünü sağlayın ve okuyucu güvenini her zaman koruyun.',
      position: { top: '50%', right: '5%' }
    },
    {
      id: 5,
      title: 'Otomatik Yedeklemeler',
      description: 'Otomatik yedeklemelerle veri güvenliğini sağlayın. Değerli içeriklerinizi asla kaybetmeyin ve her zaman içiniz rahat olsun.',
      position: { top: '85%', left: '8%' }
    },
    {
      id: 6,
      title: 'Çoklu Platform Dağıtımı',
      description: 'Entegre dağıtım araçlarıyla her yerde yayınlayın. Daha geniş kitlelere ulaşın ve haberlerinizin etkisini en üst düzeye çıkarın.',
      position: { top: '85%', right: '8%' }
    }
  ];

  // Intersection observer
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = parseInt(entry.target.dataset.index);
            setTimeout(() => {
              setVisibleFeatures(prev => new Set([...prev, index]));
            }, index * 100);
          }
        });
      },
      { threshold: 0.3 }
    );

    const elements = document.querySelectorAll('[data-index]');
    elements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <Box 
    sx={{
      background: 'linear-gradient(101deg, #15254b 0%, #1e3a8a 100%)',
    }}
    >

  <Box sx={{
        py: { xs: 10, md: 16 },
        backgroundColor:'#f1f6fb',
        borderRadius: {xs : 0, md : '400px 0 400px 0'},
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
            radial-gradient(circle at 20% 20%, rgba(30, 64, 175, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 80% 80%, rgba(220, 38, 38, 0.05) 0%, transparent 50%),
            radial-gradient(circle at 50% 50%, rgba(5, 150, 105, 0.03) 0%, transparent 50%)
          `,
          pointerEvents: 'none'
        }
      }}
    >
      {/* Beyaz shape görsel */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          //backgroundImage: `url(${templateAsset})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          opacity: 0.8, // daha beyaz görünmesi için
          filter: 'brightness(1.5) contrast(1.3)', // beyazlığı artırır
          zIndex: 1,
        }}
      />
      <Container maxWidth="lg" sx={{ position: 'relative', height: '100%' }}>

        {/* Header - Görseldeki gibi */}
        <Box sx={{ textAlign: 'center', mb: { xs: 4, md: 10 } }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.8rem', md: '4rem' },
              fontWeight: 800,
              mb: 4,
              background: 'linear-gradient(135deg, #1e293b 0%, #1e40af 50%, #dc2626 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, sans-serif',
              lineHeight: 1.1,
              position: 'relative',
              '&::after': {
                content: '""',
                position: 'absolute',
                bottom: -8,
                left: '50%',
                transform: 'translateX(-50%)',
                width: 80,
                height: 4,
                background: 'linear-gradient(90deg, #1e40af, #dc2626)',
                borderRadius: 2
              }
            }}
          >
            Yayınlama Gücünü Ortaya Çıkarın
          </Typography>

          <Typography
          variant="h5"
          sx={{
            fontSize: { xs: '1.3rem', md: '1.5rem' },
            color: '#64748b',
            maxWidth: 700,
            mx: 'auto',
            lineHeight: 1.6,
            fontWeight: 400,
            mb: 6
          }}
          >
            Rönesans Haber ile benzersiz kontrol ve verimlilik deneyimleyin. Yayıncılık iş akışınızı
            dönüştürün ve hedef kitlenizin ilgisini çekin.
          </Typography>
        </Box>

        {/* Ana Container - Telefon ve Özellikler */}
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            justifyContent: 'space-around',
            gap: { xs: 2, md: 5 }
          }}
        >

         <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-around' , height: '700px', width: '100%'}}>
         {features?.slice(0, 3).map((feature, index) => (
            <Box
            component={motion.div}
            initial={{ opacity: 0, x:  -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.1, ease: "easeIn" }}
              key={feature.id}
              data-index={index}
              sx={{
                gap:2,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: {xs : 'center', md : 'flex-end'},
                justifyContent: {xs : 'center', md : 'flex-end'},
               // width: { xs: 240, md: 280 },
                //maxWidth: '320px',
                background: 'transparent',
                color: 'white',
                //p: { xs: 2, md: 2.5 },
                cursor: 'pointer',
                transform: visibleFeatures.has(index)
                  ? 'translateY(0) scale(1)'
                  : 'translateY(20px) scale(0.98)',
                opacity: visibleFeatures.has(index) ? 1 : 0,
                transition: `all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${index * 0.1}s`,
                '&:hover': {
                  transform: 'translateY(-3px) scale(1.01)'
                },
                // Mobile responsive
                [theme => theme.breakpoints.down('md')]: {
                  display: 'none' // Mobilde gizle, alt kısımda göster
                }
              }}
            >
              {/* Turuncu Nokta - Görseldeki gibi */}
              <Box sx={{
                padding: { xs: 2, md: 1 },
                borderRadius: '50%',
                border: '1px solid rgb(255 255 255 / 26%)',
                boxShadow: '0 0 10px rgb(22 160 249 / 41%)'
              }}>
              <Box
                sx={{
                  width: { xs: 8, md: 10 },
                  height: { xs: 8, md: 10 },
                  background: '#f97316',
                  borderRadius: '50%',
                  boxShadow: '0 0 10px rgba(249, 115, 22, 0.5)'
                }}
              />
              </Box>

              {/* Özellik Başlığı */}
              <Box>
              <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: 'black',
                  mb: 2,
                  fontSize: { xs: '1.1rem', md: '1.3rem' },
                  textAlign: {xs : 'center', md : 'right'},
                  lineHeight: 1.2
                }}
              >
                {feature.title}
              </Typography>

              {/* Özellik Açıklaması */}
              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(50, 8, 8, 0.89)',
                  lineHeight: 1.5,
                  fontSize: { xs: '0.9rem', md: '1rem' },
                  textAlign: {xs : 'center', md : 'right'}
                }}
              >
                {feature.description}
              </Typography>
              </Box>
            </Box>
          ))}


         </Box>
          {/* Merkezdeki Telefon - Tam görseldeki gibi */}
          <Box
            component={'img'}
            src={phoneAsset}
            alt="Perfect"
            sx={{
              width: '28%',
              zIndex: 2
            }}
          />

           <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'space-around' , height: '700px', width: '100%', gap:2  }}>
            {/* Etraftaki Özellik Kartları - Tam görseldeki pozisyonlarda */}
          {features?.slice(3, 6).map((feature, index) => (
            <Box
            component={motion.div}
            initial={{ opacity: 0, x:  100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.2, ease: "easeIn" }}
              key={feature.id}
              data-index={index}
              sx={{
                gap:2,
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: {xs : 'center', md : 'flex-start'},
                justifyContent: {xs : 'center', md : 'flex-start'},
               // width: { xs: 240, md: 280 },
                //maxWidth: '320px',
                background: 'transparent',
                color: 'white',
                //p: { xs: 2, md: 2.5 },
                cursor: 'pointer',
                transform: visibleFeatures.has(index)
                  ? 'translateY(0) scale(1)'
                  : 'translateY(20px) scale(0.98)',
                opacity: visibleFeatures.has(index) ? 1 : 0,
                transition: `all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) ${index * 0.1}s`,
                '&:hover': {
                  transform: 'translateY(-3px) scale(1.01)'
                },
                // Mobile responsive
                [theme => theme.breakpoints.down('md')]: {
                  display: 'none' // Mobilde gizle, alt kısımda göster
                }
              }}
            >
              {/* Turuncu Nokta - Görseldeki gibi */}
              <Box sx={{
                padding: { xs: 2, md: 1 },
                borderRadius: '50%',
                border: '1px solid rgb(255 255 255 / 26%)',
                boxShadow: '0 0 10px rgb(22 160 249 / 41%)'
              }}>
              <Box
                sx={{
                  width: { xs: 8, md: 10 },
                  height: { xs: 8, md: 10 },
                  background: '#f97316',
                  borderRadius: '50%',
                  boxShadow: '0 0 10px rgba(249, 115, 22, 0.5)'
                }}
              />
              </Box>

             <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: {xs : 'center', md : 'flex-start'}, justifyContent: {xs : 'center', md : 'flex-start'} }}>
               {/* Özellik Başlığı */}
               <Typography
                variant="h5"
                sx={{
                  fontWeight: 700,
                  color: 'black',
                  mb: 2,
                  fontSize: { xs: '1.1rem', md: '1.3rem' },
                  textAlign: {xs : 'center', md : 'left'},
                  lineHeight: 1.2
                }}
              >
                {feature.title}
              </Typography>

              {/* Özellik Açıklaması */}
              <Typography
                variant="body1"
                sx={{
                  color: 'rgba(50, 8, 8, 0.89)',
                  lineHeight: 1.5,
                  fontSize: { xs: '0.9rem', md: '1rem' },
                  textAlign: {xs : 'center', md : 'left'}
                }}
              >
                {feature.description}
              </Typography>
             </Box>
            </Box>
          ))}
           </Box>
        </Box>
      </Container>
      <Box 
  sx={{
    background: `
    linear-gradient(
      36deg,
      #ffffff 0%,
      #f8fafc 25%,
      #f1f5f9 50%,
      #e2e8f0 75%,
      #cbd5e1 100%
    )
  `
  }}
  />

      {/* CSS Animations */}
      <style jsx>{`
        @keyframes pulse {
          0%, 100% { 
            opacity: 1;
            transform: scale(1);
          }
          50% { 
            opacity: 0.7;
            transform: scale(1.1);
          }
        }
      `}</style>
    </Box>
  </Box>

   
  );
};

export default MobileShowcasePerfect;